import Loader from '../reusable/Loader';
import useUserDetails from '../hooks/useUserDetails';
import useErrorModal from '../hooks/useErrorModal';
import SurveyResponseDashboardContent from './SurveyResponseDashboardContent';

const SurveyResponseDashboardPage = () => {
  const {
    userDetails: { data: userDetails },
  } = useUserDetails();
  const { handleOpen } = useErrorModal();

  if (!userDetails) return <Loader />;

  return (
    <SurveyResponseDashboardContent
      eoaId={userDetails.eoaId}
      accessToken={userDetails.access_token}
      onError={handleOpen}
    />
  );
};

export default SurveyResponseDashboardPage;
